export * from './service-call-edit.component';
export * from './service-call-edit.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-edit/index.ts